import { ColCatService } from '../../shop/services/col-cat.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FirestoreProductsService } from '../services/firestore-products.service';
import { LocalStorageService } from '../services/local-storage.service';
import { PricesService } from '../services/prices.service';
import { ProductRangeService } from '../services/product-range.service';
import { FirestoreRange } from '../interfaces/firestore-range';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-view-all',
  templateUrl: './view-all.component.html',
  styleUrls: ['./view-all.component.scss']
})

export class ViewAllComponent implements OnDestroy, OnInit {

  private category: string;
  private categoryChild: string;
  private collections: any[];
  private cost: number;
  private delivery: number;
  private depth: number;
  private discount: number;
  private filteredProducts: any;
  private finalsellingPrice: number;
  private markup: number;
  private monthEval: number;
  private monthlyPrice: number;
  private ownDiscount: number;
  private products: FirestoreRange[];
  private renewDiscount: number;
  private subCategories: any[];
  private subCollections: any[];
  private subscription: Subscription;
  private subscriptionPrice;
  private tax: number;
  private totalCollectionCost: number;
  private width: number;

  private concreteTop: boolean;
  private glassTop: boolean;
  private marbleTop: boolean;
  private woodTop: boolean;
  private tableSize: string;
  private tableTopSelection: string;
  private isRectangleTable: boolean;
  private price: number;
  private topCost: number;

  public categories: any[];
  public productList: object;

  constructor(
    public router: Router,

    private colCatService: ColCatService,
    private pricesService: PricesService,
    private productRange: ProductRangeService,
    private fsProducts: FirestoreProductsService,
    public ls: LocalStorageService
  ) {
    this.topCost = this.pricesService.concrete;
    this.subscription =
      this.colCatService.getCollections().subscribe(data => this.collections = data),
      this.colCatService.subCollection().subscribe(data => this.subCollections = data),
      this.colCatService.category().subscribe(data => this.categories = data),
      this.colCatService.subCategory().subscribe(data => this.subCategories = data);
    this.catFilter();
    this.initPriceConstants();
    this.subcribeMonth();
    this.initLsValues();
  }

  ngOnInit() {
    console.log(this.category);
    this.filterBy('category', this.category);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private catFilter(): void {
    const tempVal: string[] = this.router.url.split('/');
    this.category = tempVal[1];
  }

  private filterBy(key: string, value: string) {
    this.filteredProducts = this.fsProducts.filterBy(key, value).subscribe(documents => {
      console.log(documents);
      this.productRange.castBaseStamp(documents);
      this.subscribeProductRange();
    });
  }

  private initCustomVals(): void {
    this.concreteTop = true;
    this.glassTop = false;
    this.marbleTop = false;
    this.woodTop = false;

    this.tableSize = '4-6';
    this.tableTopSelection = 'concrete';


    if (this.isRectangleTable === true) {
      this.depth = 900;
      this.width = 1200;
    } else {
      this.depth = 1200;
      this.width = 1200;
    }
  }

  private initLsValues(): void {
    const currentMonth: string = localStorage.getItem('monthSelection');

    if (currentMonth !== null || currentMonth !== undefined) {
      this.ls.monthWrite(currentMonth);
    }
  }

  private initPriceConstants(): void {
    this.cost = 0;
    this.delivery = this.pricesService.delivery;
    this.discount = this.pricesService.discount;
    this.markup = this.pricesService.markup;
    this.ownDiscount = this.pricesService.ownDiscount;
    this.renewDiscount = this.pricesService.renewDiscount;
    this.tax = this.pricesService.taxVal;
  }

  private monthPrice(cost: number): number {
    const retailPrice = this.sellingPrice(cost);
    const correctCost = this.pricesService.monthlySubscriptionPrices(this.discount, this.monthEval, retailPrice);
    this.monthlyPrice = correctCost;
    return correctCost;
  }

  public subcribeMonth(): void {
    this.subscription = this.ls.monthListener().subscribe(month => {
      if (month) {
        this.monthEval = this.ls.filterInt(month);
      } else {
        this.monthEval = 0;
      }
    });
  }

  private sellingPrice(cost: number): number {
    if (this.categoryChild === 'dining-tables') {
      let depth = this.depth;
      let width = this.width;

      if (this.isRectangleTable === true) {
        if (this.tableSize === '4-6') {
          depth = 900;
          width = 1200;
        } else if (this.tableSize === '6-8') {
          depth = 2000;
          width = 1000;
        } else if (this.tableSize === '8-10') {
          depth = 2750;
          width = 1200;
        }
      } else if (this.isRectangleTable === false) {
        if (this.tableSize === '4-6') {
          depth = 1200;
          width = 1200;
        } else if (this.tableSize === '6-8') {
          depth = 1500;
          width = 1500;
        }
      }

      this.price = this.pricesService.tableSellingPrice(cost, this.delivery, depth, this.markup, this.isRectangleTable, this.tableSize, this.topCost, this.tax, width);

      // console.table([
      //   {'cost': cost},
      //   {'depth': depth},
      //   {'delivery': this.delivery},
      //   {'discount': this.discount},
      //   {'isRectangleTable': this.isRectangleTable},
      //   {'markup': this.markup},
      //   {'monthEval': this.monthEval},
      //   {'ownDiscount': this.ownDiscount},
      //   {'tablePrice': this.tablePrice},
      //   {'tablePrice (with discounts)': this.tablePrice * (1 - (this.ownDiscount / 100)) - (this.pricesService.monthlySubscriptionPrices(this.discount, this.monthEval, this.tablePrice) * this.monthEval)},
      //   {'tableSize': this.tableSize},
      //   {'tax': this.tax},
      //   {'topCost': this.topCost},
      //   {'width': width},
      // ]);

      return this.price;
      // return this.tablePrice * (1 - (this.ownDiscount / 100)) - (this.pricesService.monthlySubscriptionPrices(this.discount, this.monthEval, this.tablePrice) * this.monthEval);
    } else if (this.categoryChild !== 'dining-tables') {

      // console.log([
      //   {'cost': this.cost},
      //   {'delivery': this.delivery},
      //   {'markup': this.markup},
      //   {'monthEval': this.monthEval},
      //   {'ownDiscount': this.ownDiscount},
      //   {'tablePrice': this.pricesService.sellingPrice(this.cost, this.delivery, this.markup, this.tax)},
      //   {'tax': this.tax},
      // ]);

      this.price = this.price = this.pricesService.sellingPrice(cost, this.delivery, this.markup, this.tax);
      return this.price;
    }
  }

  public subscribeProductRange(): void {
    this.productRange.productObs().subscribe(documents => {
      this.initCustomVals();
      this.productList = documents;
      console.log(documents);
      console.log(this.productList);
    });
  }
}
